export default "__VITE_ASSET__n$R6OQBy__"